import { useMemo } from 'react';
import { useDebounce } from 'usehooks-ts';
import api from 'lib/trpcClient';

type Props = {
  subscriptionCode: string | undefined;
  firmId: string | undefined;
  investmentId?: string;
};

export const useSubscriptionCodeWarning = ({
  subscriptionCode,
  firmId,
  investmentId,
}: Props) => {
  const debouncedCode = useDebounce(subscriptionCode ?? '', 300);

  const { data } = api.investment.checkSubscriptionCodeInUse.useQuery(
    {
      externalInvestmentId: debouncedCode,
      firmId: firmId ?? '',
      investmentId,
    },
    { enabled: !!debouncedCode && !!firmId },
  );

  return useMemo(
    () => ({
      hasWarning: debouncedCode && data === true,
      message:
        'Please note: This ID is already in use on another subscription and reusing it could complicate data transfer to your custodian.',
    }),
    [data, debouncedCode],
  );
};
